$(function() {
  $('form').each(function() {  // attach to all form elements on page
    let validobj = $(this).validate({
      // errorContainer: '.error-container',
      // errorLabelContainer: '.error-container ul',
      // wrapper: 'li',
      ignore: [], // Required to work with select2
      rules: {
        graphicStyleRadio: {
          required: function (element) {
            let boxes = $('.graphicStyleRadio');
          console.log(boxes);

            if (boxes.filter(':checked').length === 0) {
              return true;
            }
            return false;
          },
          minlength: 1
        }
      },
      messages: {
        // graphicStyleRadio: "Please select at least two types of spam."
      },
      onkeyup: false,
      errorClass: "myErrorClass",
      errorPlacement: function (error, element) {
        // var elem = $(element);
        // error.insertAfter(element);
      },
      highlight: function (element, errorClass, validClass) {
        let elem = $(element);
        if (elem.hasClass('select2-hidden-accessible')) {
          $('#select2-' + elem.attr('id') + '-container').parent().addClass(errorClass);
        } else {
          elem.addClass(errorClass);
        }
        if (elem.hasClass('graphicStyleRadio')) {
          elem.parent().parent().parent('section').addClass('blockErrorClass');
        } else {
          elem.removeClass('blockErrorClass');
        }
      },
      unhighlight: function (element, errorClass, validClass) {
        let elem = $(element);
        if (elem.hasClass('select2-hidden-accessible')) {
          $('#select2-' + elem.attr('id') + '-container').parent().removeClass(errorClass);
        } else {
          elem.removeClass(errorClass);
        }

        if (elem.hasClass('graphicStyleRadio')) {
          elem.parent().parent().parent('section').removeClass('blockErrorClass');
        } else {
          elem.removeClass('blockErrorClass');
        }
      }
    });

    $('.graphicStyle').on('click', function(){
      let currentForm = $(this).closest('form');
      $(currentForm).valid();
    });

    $(document).on('change', '.select2-hidden-accessible', function () {
      if (!$.isEmptyObject(validobj.submitted)) {
        validobj.form();
      }
    });

    $(document).on('select2:opening', function (arg) {
      let elem = $(arg.target);
      if ($('#select2-' + elem.attr('id') + '-container').hasClass('myErrorClass')) {
        //jquery checks if the class exists before adding.
        $('.select2-container').addClass('myErrorClass');
      } else {
        $('.select2-container').removeClass('myErrorClass');
      }
    });
  });
});
